// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___IuTs0","root__avatar":"style-module__root__avatar___HasGr","root__wrapper":"style-module__root__wrapper___BpW3y","root__wrapper_list__wrapper":"style-module__root__wrapper_list__wrapper___qB1Bb","root__wrapper_list__item":"style-module__root__wrapper_list__item___BpTyR","root__btn":"style-module__root__btn___bHQSj"};
    if(module.hot) {
      // 1729151123668
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  